import {
    IconHome2,
    IconNews,
    IconAppWindow,
    IconNotebook,
    IconUsers,
    IconDevices2
} from "@tabler/icons";

export const data = [
    { label: "Home", link: "/", icon: IconHome2 },
    { label: "Users", link:"/users", icon:IconUsers},
    { label: "Coworking", link: "/coworking", icon: IconDevices2 },
    { label: "Courses", link: "/courses", icon: IconNotebook },
    { label: "News", link: "/news", icon: IconNews },
    { label: "Projects", link: "/projects", icon: IconAppWindow },
];
